import ActivateLandingScreen from '../screens/Activate/ActivateAccount'
import ActivateWelcomeScreen from '../screens/Activate/ActivateAccount/welcome'
import ActivateScreen from '../screens/Activate/Resend'
import ChatScreen from '../screens/Admin/Chat'
import AdminScreen from '../screens/Admin/Dashboard'
import AdminRealtyListScreen from '../screens/Admin/Realty/List'
import AdminRealtyShowScreen from '../screens/Admin/Realty/Show'
import UserCreateScreen from '../screens/Admin/User/Create'
import UserEditScreen from '../screens/Admin/User/Edit'
import UserListScreen from '../screens/Admin/User/List'
import UserShowScreen from '../screens/Admin/User/Show'
import ContactScreen from '../screens/Contact'
import FaqScreen from '../screens/Faq'
import ForgotScreen from '../screens/Forgot'
import HomeScreen from '../screens/Home'
import LoginScreen from '../screens/Login'
import RealtyCreateScreen from '../screens/Realty/Create'
import RealtyEditScreen from '../screens/Realty/Edit'
import RealtyListScreen from '../screens/Realty/List'
import ResetScreen from '../screens/Reset'
import PrivacyScreen from '../screens/Privacy'
import TermsScreen from '../screens/Terms'
import SessionScreen from '../screens/Session'
import SettingsScreen from '../screens/Settings'
import SettingsMenuScreen from '../screens/Settings/settings-menu'
import AccountScreen from '../screens/Settings/Account'
import SecurityScreen from '../screens/Settings/Security'
import ChangeEmailScreen from '../screens/Settings/Security/ChangeEmail'
import ChangePasswordScreen from '../screens/Settings/Security/ChangePassword'

const routes = {
  index: {
    path: '/',
    component: HomeScreen,
  },
  login: {
    path: '/login',
    component: LoginScreen,
  },
  account_activation: {
    path: '/account-activation',
    component: ActivateScreen,
  },
  activation_landing: {
    path: '/email/verify/:user_id/:hash',
    component: ActivateLandingScreen,
  },
  activation_welcome: {
    path: '/welcome',
    component: ActivateWelcomeScreen,
  },
  forgot: {
    path: '/forgot',
    component: ForgotScreen,
  },
  privacy: {
    path: '/privacy',
    component: PrivacyScreen,
  },
  terms: {
    path: '/terms',
    component: TermsScreen,
  },
  reset: {
    path: '/reset/:token?',
    component: ResetScreen,
  },
  faq: {
    path: '/faq',
    component: FaqScreen,
  },
  contact: {
    path: '/contact',
    component: ContactScreen,
  },
  realty: {
    index: {
      path: '/realty',
      component: RealtyListScreen,
    },
    create: {
      path: '/realty/new',
      component: RealtyCreateScreen,
    },
    edit: {
      path: '/realty/:id/edit',
      pathFor: (id: number) => '/realty/' + id + '/edit',
      component: RealtyEditScreen,
    },
    show: {
      path: '/realty/:id',
      pathFor: (id: number) => '/realty/' + id,
      component: RealtyEditScreen,
    },
  },
  settings: {
    index: {
      path: '/settings',
      component: SettingsScreen,
    },
    menu: {
      path: '/settings-menu',
      component: SettingsMenuScreen,
    },
    account: {
      path: '/settings/account',
      component: AccountScreen,
    },
    security: {
      index: {
        path: '/settings/security',
        component: SecurityScreen,
      },
      email: {
        path: '/settings/security/email',
        component: ChangeEmailScreen,
      },
      password: {
        path: '/settings/security/password',
        component: ChangePasswordScreen,
      },
      session: {
        path: '/settings/security/session',
        component: SessionScreen,
      },
    },
  },
  admin: {
    index: {
      path: '/admin',
      component: AdminScreen,
    },
    realty: {
      index: {
        path: '/admin/realty',
        component: AdminRealtyListScreen,
      },
      show: {
        path: '/admin/realty/:id',
        pathFor: (id: number) => '/admin/realty/' + id,
        component: AdminRealtyShowScreen,
      },
      edit: {
        path: '/admin/realty/:id/eidt',
        pathFor: (id: number) => `/admin/realty/${id}/edit`,
        component: AdminRealtyShowScreen,
      },
    },
    user: {
      index: {
        path: '/admin/user',
        component: UserListScreen,
      },
      show: {
        path: '/admin/user/:id',
        pathFor: (id: number) => '/admin/user/' + id,
        component: UserShowScreen,
      },
      create: {
        path: '/admin/user/create',
        component: UserCreateScreen,
      },
      edit: {
        path: '/admin/user/:id/edit',
        pathFor: (id: number) => `/admin/user/${id}/edit`,
        component: UserEditScreen,
      },
    },
    chat: {
      path: '/admin/chat',
      pathFor: (room: string) => `/admin/chat?room=${room}`,
      component: ChatScreen,
    },
  },
}

export default routes
